import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-organizations',
  templateUrl: './layout-organizations.component.html',
  styleUrls: ['./layout-organizations.component.sass']
})
export class LayoutOrganizationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
